import { useEffect } from "react";
import MuiTextField from "@mui/material/TextField";
import type { TextFieldProps as MuiTextFieldProps } from "@mui/material/TextField";
import { get } from "lodash";
import { useFormikContext } from "formik";
import type { SystemStyleObject, Theme } from "@mui/system";

import { useFormContext } from "@/hooks/useFormContext";
import { FormSkeleton } from "../../skeleton";

type FormValues = Record<string, unknown>;

export interface TextFieldProps extends Omit<MuiTextFieldProps, "error"> {
  loading?: boolean;
  readonly?: boolean;
  error?: string;
}

export function TextField({
  id,
  name,
  label,
  variant,
  onError,
  value,
  placeholder,
  onChange,
  InputProps,
  loading,
  readonly,
  type,
  helperText,
  sx,
  error,
  ...rest
}: TextFieldProps) {
  const formik = useFormikContext<FormValues>();
  const formContext = useFormContext();
  const fieldName = name as string;

  useEffect(() => {
    formik.setFieldError(fieldName, error);
  }, [error]);

  return (
    <FormSkeleton loading={loading ?? formContext?.loading}>
      <MuiTextField
        id={id}
        name={name}
        type={type}
        variant={variant}
        disabled={readonly}
        placeholder={placeholder}
        label={label}
        onError={onError}
        value={value ?? get(formik.values, fieldName, "")}
        onChange={onChange ?? (name ? formik.handleChange : undefined)}
        error={get(formik?.touched, fieldName) && Boolean(get(formik.errors, fieldName))}
        helperText={get(formik?.touched, fieldName) ? get(formik.errors, fieldName) : helperText}
        InputProps={{ ...InputProps }}
        sx={{ width: "100%", ...(sx as SystemStyleObject<Theme>) }}
        {...rest}
      />
    </FormSkeleton>
  );
}
